import React, { useRef, useState, useEffect, useCallback } from "react";
import "../../components/addpropertydetails/addpropertydetails.css";
import Header from "../../components/Navbar";
import Footer from "../../components/footer/footer";
import { FaInfoCircle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Uploadicon from "../../myimgs/Layer_1 (26).png";
import "../Editproperty/editproperty.css";
import {
  LoadScript,
  GoogleMap,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import axios from "axios";
import {
  propertyType,
  years,
  buildingTypes,
  province,
  architectural_style,
  flooring,
  cooling,
  heatings,
  exterior,
  fireplaced,
  Parking,
} from "../../data/states";
const libraries = ["places"];
const timing = [
  "12AM", "1AM", "2AM", "3AM", "4AM", "5AM",
  "6AM", "7AM", "8AM", "9AM", "10AM", "11AM",
  "12PM", "1PM", "2PM", "3PM", "4PM", "5PM",
  "6PM", "7PM", "8PM", "9PM", "10PM", "11PM"
];

const residentialTypes = [
  "Residential",
  "Condo/Strata",
  "Vacant Land",
  "Single Family",
  "Recreational",
  "Multi-family",
  "Agriculture",
  "Parking",
  "Other",
];

const commercialTypes = [
  "Business",
  "Multi-family",
  "Retail",
  "Industrial",
  "Office",
  "Vacant Land",
  "Agriculture",
  "Hospitality",
  "Institutional",
  "Other",
];

/**
 * Mapping object to convert Google Maps short codes (e.g., 'ON')
 * to the full names used in your 'province' data array (e.g., 'ONTARIO').
 */
const provinceCodeMap = {
  AB: "ALBERTA",
  BC: "BRITISH COLUMBIA",
  MB: "MANITOBA",
  NB: "NEW BRUNSWICK",
  NL: "NEWFOUNDLAND AND LABRADOR",
  NS: "NOVA SCOTIA",
  NT: "NORTHWEST TERRITORIES",
  NU: "NUNAVUT",
  ON: "ONTARIO",
  PE: "PRINCE EDWARD ISLAND",
  QC: "QUEBEC",
  SK: "SASKATCHEWAN",
  YT: "YUKON",
};
// ====================================================================================
function EditProperty() {
  // Extract query params from URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const propertyId = queryParams.get("id");
  const propeId = queryParams.get("propeId");
  const [listingId, setListingId] = useState(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [error, setError] = useState("");
  const userId = localStorage.getItem("userId");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null); // Building Type
  const architecturalDropRef = useRef(null); // Architectural Style
  const flooringDropRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  // ADDED: State for loading indicator
  const [isLoading, setIsLoading] = useState(false);
  //ADDED: State to track if the address has been verified for the current input
  const [isAddressVerified, setIsAddressVerified] = useState(false);
  //ADDED: State to store the last verified address string for comparison
  const [lastVerifiedAddress, setLastVerifiedAddress] = useState("");
  const autocompleteRef = useRef(null);
  const [selectedPosition, setSelectedPosition] = useState({
    lat: 20.5937, // Default: India center
    lng: 78.9629,
  });
  // multipal selecte .. ..
  const [architecturalOpen, setArchitecturalOpen] = useState(false);
  const [flooringOpen, setFlooringOpen] = useState(false); // Flooring
  const [coolingOpen, setCoolingOpen] = useState(false);
  const coolingDropRef = useRef(null);
  const [heatingOpen, setHeatingOpen] = useState(false);
  const heatingDropRef = useRef(null);
  const [exteriorOpen, setExteriorOpen] = useState(false);
  const exteriorDropRef = useRef(null);
  const [fireplaceOpen, setFireplaceOpen] = useState(false);
  const fireplaceDropRef = useRef(null);
  const [parkingOpen, setParkingOpen] = useState(false);
  const parkingDropRef = useRef(null);

const [isResidential, setIsResidential] = useState(true);
const propertyTypeOptions = isResidential
  ? residentialTypes
  : commercialTypes;
  // multipal selecte .. ..
  const [formData, setFormData] = useState({
    /* -------- Case 1 Fields -------- */
    propertySubType: "",
    structureType: [],
    architecturalStyle: [],
    yearBuilt: "",
    propertyCondition: [],
    stories: "",
    zoning: [],
    zoningDescription: "",
    parcelNumber: [],
    listPrice: "",
    offerStartingPrice: "",
    offerStartingDate: "",
    offerEndingDate: "",
    offerStartingTime: "",
    offerEndingTime: "",
    /* -------- Case 2 Fields (Address) -------- */
    unparsedAddress: "", // FULL address → from Autocomplete
    streetName: "",
    streetNumber: "",
    unitNumber: "",
    subdivisionName: "",
    municipality: "",
    postalCode: "",
    city: "",
    stateOrProvince: "", // province renamed for API
    country: "Canada",
    directions: "", // locationDirection renamed
    latitude: "", // lat renamed for API
    longitude: "",
    /* -------- Case 3 Fields -------- */
    // ---------- Property Features Updated for API ----------
    bedroomsTotal: "",
    bedroomsAboveGrade: "",
    bedroomsBelowGrade: "",
    bathroomsTotalInteger: "",
    bathroomsPartial: "",
    rooms: "",
    livingArea: "",
    livingAreaUnits: "",
    livingAreaSource: "",
    livingAreaMinimum: "",
    livingAreaMaximum: "",
    buildingAreaTotal: "",
    buildingAreaUnits: "",
    buildingFeatures: [], // array
    basement: [], // array
    flooring: [], // array
    cooling: [], // array
    heating: [], // array
    foundationDetails: [], // array
    exteriorFeatures: [], // array
    roof: [], // array
    waterSource: [], // array
    sewer: [], // array
    electric: [], // array
    utilities: [], // array
    irrigationSource: [], // array
    fireplacesTotal: "",
    fireplaceYN: "yes",
    fireplaceFeatures: [], // array
    accessibilityFeatures: [], // array
    constructionMaterials: [], // array
    appliances: [], // array
    otherEquipment: [], // array
    currentUse: [],
    possibleUse: [],
    securityFeatures: [], // array
    /* -------- Case 4 Fields -------- */
    numberOfBuildings: "",
    numberOfUnitsTotal: "",
    lotFeatures: [],
    lotSizeArea: "",
    lotSizeDimensions: "",
    lotSizeUnits: "",
    frontageLengthNumeric: "",
    frontageLengthNumericUnits: "",
    poolFeatures: [],
    fencing: [],
    roadSurfaceType: [],
    parkingFeatures: [],
    parkingTotal: "",
    waterfrontFeatures: [],
    waterBodyName: "",
    communityFeatures: [],
    associationFee: "",
    associationFeeFrequency: "",
    associationName: "",
    associationFeeIncludes: [],
    totalActualRent: "",
    existingLeaseType: [],
    leaseAmount: "",
    leaseAmountFrequency: "",
    leasePerUnit: "",
    pricePerUnit: "",
    businessType: [],
    anchorsCoTenants: "",
    view: [],
    propertyAttachedYN: "true",
    taxAnnualAmount: "",
    taxBlock: "",
    taxLot: "",
    taxYear: "",
    publicRemarks: "",
  });
  // uploads case5
  const ownershipRef = useRef();
  const identityRef = useRef();
  const [ownershipPreview, setOwnershipPreview] = useState([]);
  const [identityPreview, setIdentityPreview] = useState([]);
  const [ownershipError, setOwnershipError] = useState("");
  const [identityError, setIdentityError] = useState("");
  const [ownershipFile, setOwnershipFile] = useState(null);
  const [identityFile, setIdentityFile] = useState(null);

  // uploads case5
  const handleOwnershipChange = (e) => {
    // ❌ If old file exists → block new upload
    if (ownershipPreview.length > 0) {
      setOwnershipError(
        "Please delete the existing ownership document before uploading a new one."
      );
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    setOwnershipFile(file);
    setOwnershipPreview([URL.createObjectURL(file)]);
    setOwnershipError("");
  };

  const handleIdentityChange = (e) => {
    // ❌ If old file exists → block new upload
    if (identityPreview.length > 0) {
      setIdentityError(
        "Please delete the existing identity document before uploading a new one."
      );
      return;
    }

    const file = e.target.files[0];
    if (!file) return;

    setIdentityFile(file);
    setIdentityPreview([URL.createObjectURL(file)]);
    setIdentityError("");
  };

  // const removeOwnership = (index) => {
  //   setOwnershipPreview((prev) => prev.filter((_, i) => i !== index));
  // };
  // const removeIdentity = (index) => {
  //   setIdentityPreview((prev) => prev.filter((_, i) => i !== index));
  // };
  const [previewImages, setPreviewImages] = useState([]); // URLs for <img>
  const [uploadedImages, setUploadedImages] = useState([]); // Actual File objects for FormData
  const [errors, setErrors] = useState({});
  const totalSteps = 5;
  // Total number of steps
  const [ownershipFiles, setOwnershipFiles] = useState([]);
  const [identityFiles, setIdentityFiles] = useState([]);
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 0) {
      files.forEach((file) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          const ratio = width / height;
          if (ratio >= 1.2) {
            // Add new file object with correct structure to previewImages
            setPreviewImages((prev) => [
              ...prev,
              {
                id: null, // new image doesn't have id yet
                url: URL.createObjectURL(file),
                isNew: true, // mark it new
                file: file, // keep original file for upload
              },
            ]);
            setUploadedImages((prev) => [...prev, file]); // for upload
            setError(""); // clear error
          } else {
            setError(
              `"${file.name}" is not valid. Please upload a landscape (wide) image.`
            );
          }
        };
      });
    }
  };

  const handleImageRemove = async (index) => {
    const image = previewImages[index];
    if (!image) return;

    // Old image → call POST API to remove
    if (!image.isNew && image.id) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/images/remove/${image.id}`,
          {
            method: "POST",
          }
        );

        const data = await response.json();

        if (!response.ok || data.status !== 200) {
          Swal.fire({
            icon: "error",
            title: "Failed to delete image from server",
          });
          return;
        }
      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire({
          icon: "error",
          title: "Server error while deleting",
        });
        return;
      }
    }

    // Remove from UI
    setPreviewImages((prev) => prev.filter((_, i) => i !== index));
  };

  const removeOwnership = async (index) => {
    const doc = ownershipPreview[index];

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/disclaimer/status-doc/${doc.id}`
      );

      // Update UI (no reload)
      setOwnershipPreview((prev) => prev.filter((_, i) => i !== index));
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const removeIdentity = async (index) => {
    const doc = identityPreview[index];

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/disclaimer/status-doc/${doc.id}`
      );

      setIdentityPreview((prev) => prev.filter((_, i) => i !== index));
    } catch (err) {
      console.error(err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  // For date input (YYYY-MM-DD)
  // const formatDateForInput = (dateTimeString) => {
  //   if (!dateTimeString) return "";

  //   const date = new Date(dateTimeString);

  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");

  //   return `${year}-${month}-${day}`; // local date
  // };
  // YYYY-MM-DD (UTC based)
const formatDateForInput = (dateTimeString) => {
  if (!dateTimeString) return "";

  const date = new Date(dateTimeString);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


  // const getTimeFromDateTime = (dateTimeStr) => {
  //   if (!dateTimeStr) return "";

  //   const date = new Date(dateTimeStr);
  //   let hours = date.getHours(); // IST
  //   const ampm = hours >= 12 ? "PM" : "AM";

  //   hours = hours % 12;
  //   if (hours === 0) hours = 12;

  //   return `${hours}${ampm}`; // "4AM", "8PM"
  // };

const getTimeFromDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  const date = new Date(dateTimeStr);

  let hours = date.getUTCHours(); // ✅ IMPORTANT
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  if (hours === 0) hours = 12;

  return `${hours}${ampm}`;
};




  const getFileName = (url) => {
    try {
      return url.split("/").pop(); // last part (e.g., abc.pdf)
    } catch {
      return "file";
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // List of fields that require address verification if changed
    const addressFields = [
      "address",
      "postalCode",
      "municipality",
      "streetNumber",
      "streetName",
      "city",
      "province",
      "locationDirection",
      "subdivisionName",
      "unitNumber",
    ];

    if (name === "financing" && type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        financing: value,
      }));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });

      //  UPDATE: If any address field changes, reset verification status
      if (addressFields.includes(name)) {
        setIsAddressVerified(false);
      }
    }
  };

  /**
   * @function onPlaceSelect
   * Handles the selection of an address from the Autocomplete dropdown.*/
  const onPlaceSelect = () => {
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace();
      console.log("Selected Place:", place);

      let newPostalCode = "";
      let newMunicipality = "";
      let newStreetNumber = "";
      let newStreetName = "";
      let newCity = "";
      let newProvince = "";
      let newLat = null;
      let newLng = null;

      if (place.address_components) {
        for (const component of place.address_components) {
          const types = component.types;
          if (types.includes("postal_code")) {
            newPostalCode = component.long_name;
          } else if (types.includes("locality")) {
            newCity = component.long_name;
          } else if (types.includes("administrative_area_level_2")) {
            newMunicipality = component.long_name;
          } else if (types.includes("street_number")) {
            newStreetNumber = component.long_name;
          } else if (types.includes("route")) {
            newStreetName = component.long_name;
          } else if (types.includes("administrative_area_level_1")) {
            const shortCode = component.short_name;
            newProvince = provinceCodeMap[shortCode] || shortCode;
          }
        }
      }

      if (place.geometry?.location) {
        newLat = place.geometry.location.lat();
        newLng = place.geometry.location.lng();
      }

      const formattedAddress =
        place.formatted_address || place.name || formData.address;

      // Update state with autofilled data
      setFormData((prev) => ({
        ...prev,
        address: formattedAddress,
        postalCode: newPostalCode,
        municipality: newMunicipality,
        streetNumber: newStreetNumber,
        streetName: newStreetName,
        city: newCity,
        province: newProvince,
        lat: newLat || prev.lat,
        lng: newLng || prev.lng,
      }));

      // Update the map's default center if coordinates are available
      if (newLat && newLng) {
        setSelectedPosition({ lat: newLat, lng: newLng });
      }

      // ADDED: If Autocomplete changes the address, reset verification
      setIsAddressVerified(false);

      console.log("Form data updated from Autocomplete.");
    }
  };
  // Geocoding function to convert address to Lat/Lng
  const geocodeAddress = useCallback((addressString) => {
    return new Promise((resolve, reject) => {
      if (
        !window.google ||
        !window.google.maps ||
        !window.google.maps.Geocoder
      ) {
        return reject("Google Maps Geocoder not loaded.");
      }
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: addressString }, (results, status) => {
        if (status === "OK" && results[0]) {
          const lat = results[0].geometry.location.lat();
          const lng = results[0].geometry.location.lng();
          resolve({ lat, lng });
        } else {
          reject(`Geocode failed: ${status}`);
        }
      });
    });
  }, []);
  // Map Verification Handler
  const handleVerifyAddress = async (e) => {
    e.preventDefault();
    const { address, city, postalCode } = formData;
    const currentAddressString = `${address}, ${city}, ${postalCode}, Canada`;
    if (isAddressVerified && currentAddressString === lastVerifiedAddress) {
      Swal.fire({
        icon: "info",
        title: "Address Already Verified",
        text: "This address has already been successfully verified. Change the address fields to re-verify.",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (!address || !city || !postalCode) {
      Swal.fire({
        icon: "warning",
        title: "Missing Address Info",
        text: "Please fill Address, City, and Postal Code before verifying on map.",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    setIsLoading(true);
    setError("");
    try {
      let newLat = formData.latitude;
      let newLng = formData.longitude;
      // If default India center OR empty values
      if (!newLat || !newLng || (newLat === 20.5937 && newLng === 78.9629)) {
        const coords = await geocodeAddress(currentAddressString);
        newLat = coords.lat;
        newLng = coords.lng;
      }
      // Update map position
      setSelectedPosition({ lat: newLat, lng: newLng });
      // Save to formData (IMPORTANT)
      setFormData((prev) => ({
        ...prev,
        latitude: newLat,
        longitude: newLng,
      }));
      setShowPopup(true);
    } catch (err) {
      console.error("Geocoding Error:", err);
      Swal.fire({
        icon: "error",
        title: "Location Not Found",
        text: "Could not find the address. Please check your input or drag the marker manually.",
        footer: `Attempted Address: ${currentAddressString}`,
      });
      setShowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();

    // STEP 2 → Address must be verified
    if (currentStep === 2 && !isAddressVerified) {
      Swal.fire({
        icon: "warning",
        title: "Verification Required",
        text: "Please verify the address on the map before proceeding to the next step.",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    // ==============================
    //  API HIT CONDITIONS
    // ==============================
    const mustHitAPI = currentStep === 4 || (currentStep === 1 && listingId);

    // ==============================
    //  VALIDATION WHEN listingId EXISTS
    // ==============================
    if (listingId) {
      if (
        !formData.offerStartingPrice ||
        !formData.offerStartingDate ||
        !formData.offerEndingDate ||
        !formData.time ||
        !formData.endtime
      ) {
        Swal.fire({
          icon: "warning",
          title: "Missing Required Fields",
          text: "Please fill all offer-related fields before proceeding.",
        });
        return; // STOP → API will NOT hit
      }
    }

    if (mustHitAPI) {
      try {
        // Helpers
        const cleanArray = (v) =>
          !v || v === "" ? [] : Array.isArray(v) ? v : [v];
        const toString = (v) => (v ? String(v) : "");
        const toBool = (v) => (v === true || v === "true" ? true : false);

        // ==============================
        //  PAYLOAD
        // ==============================
        const payload = {
          /* ---------------- Case 1 ---------------- */
          listingId: toString(listingId),
          userId: toString(userId),
          id: toString(propertyId),
          propertySubType: toString(formData.propertyType),
          structureType: cleanArray(formData.buildingType),
          architecturalStyle: cleanArray(formData.architecturalStyle),
          yearBuilt: toString(formData.yearBuilt),
          propertyCondition: cleanArray(formData.propertyCondition),
          stories: toString(formData.stories),
          zoning: cleanArray(formData.zoning),
          zoningDescription: toString(formData.zoningDescription),
          parcelNumber: cleanArray(formData.parcelNumber),
          listPrice: toString(formData.listPrice),
          offerStartingPrice: toString(formData.offerStartingPrice),
          offerStartingDate: formatDate(formData.offerStartingDate),
          offerEndingDate: formatDate(formData.offerEndingDate),
          offerStartingTime: toString(formData.time),
          offerEndingTime: toString(formData.endtime),

          /* ---------------- Case 2 (Address) ---------------- */
          unparsedAddress: toString(formData.address),
          streetName: toString(formData.streetName),
          streetNumber: toString(formData.streetNumber),
          unitNumber: toString(formData.unitNumber),
          subdivisionName: toString(formData.subdivisionName),
          municipality: toString(formData.municipality),
          postalCode: toString(formData.postalCode),
          city: toString(formData.city),
          stateOrProvince: toString(formData.stateOrProvince),
          country: toString(formData.country),
          directions: toString(formData.directions),
          latitude: toString(formData.latitude),
          longitude: toString(formData.longitude),

          /* ---------------- Case 3 ---------------- */
          bedroomsTotal: toString(formData.bedroomsTotal),
          bedroomsAboveGrade: toString(formData.bedroomsAboveGrade),
          bedroomsBelowGrade: toString(formData.bedroomsBelowGrade),
          bathroomsTotalInteger: toString(formData.bathroomsTotalInteger),
          bathroomsPartial: toString(formData.bathroomsPartial),
          rooms: toString(formData.rooms),
          livingArea: toString(formData.livingArea),
          livingAreaUnits: toString(formData.livingAreaUnits),
          livingAreaSource: toString(formData.livingAreaSource),
          livingAreaMinimum: toString(formData.livingAreaMinimum),
          livingAreaMaximum: toString(formData.livingAreaMaximum),
          buildingAreaTotal: toString(formData.buildingAreaTotal),
          buildingAreaUnits: toString(formData.buildingAreaUnits),
          buildingFeatures: cleanArray(formData.buildingFeatures),
          basement: cleanArray(formData.basement),
          flooring: cleanArray(formData.flooring),
          cooling: cleanArray(formData.cooling),
          heating: cleanArray(formData.heating),
          foundationDetails: cleanArray(formData.foundationDetails),
          exteriorFeatures: cleanArray(formData.exteriorFeatures),
          roof: cleanArray(formData.roof),
          waterSource: cleanArray(formData.waterSource),
          sewer: cleanArray(formData.sewer),
          electric: cleanArray(formData.electric),
          utilities: cleanArray(formData.utilities),
          irrigationSource: cleanArray(formData.irrigationSource),
          fireplacesTotal: toString(formData.fireplacesTotal),
          fireplaceYN: toBool(formData.fireplacesTotal > 0),
          fireplaceFeatures: cleanArray(formData.fireplaceFeatures),
          accessibilityFeatures: cleanArray(formData.accessibilityFeatures),
          constructionMaterials: cleanArray(formData.constructionMaterials),
          appliances: cleanArray(formData.appliances),
          otherEquipment: cleanArray(formData.otherEquipment),
          securityFeatures: cleanArray(formData.securityFeatures),
          currentUse: cleanArray(formData.currentUse),
          possibleUse: cleanArray(formData.possibleUse),

          /* ---------------- Case 4 ---------------- */
          numberOfBuildings: toString(formData.numberOfBuildings),
          numberOfUnitsTotal: toString(formData.numberOfUnitsTotal),
          lotFeatures: cleanArray(formData.lotFeatures),
          lotSizeArea: toString(formData.lotSizeArea),
          lotSizeDimensions: toString(formData.lotSizeDimensions),
          lotSizeUnits: toString(formData.lotSizeUnits),
          frontageLengthNumeric: toString(formData.frontageLengthNumeric),
          frontageLengthNumericUnits: toString(
            formData.frontageLengthNumericUnits
          ),
          poolFeatures: cleanArray(formData.poolFeatures),
          fencing: cleanArray(formData.fencing),
          roadSurfaceType: cleanArray(formData.roadSurfaceType),
          parkingFeatures: cleanArray(formData.parkingFeatures),
          parkingTotal: toString(formData.parkingTotal),
          waterfrontFeatures: cleanArray(formData.waterfrontFeatures),
          waterBodyName: toString(formData.waterBodyName),
          communityFeatures: cleanArray(formData.communityFeatures),
          associationFee: toString(formData.associationFee),
          associationFeeFrequency: toString(formData.associationFeeFrequency),
          associationName: toString(formData.associationName),
          associationFeeIncludes: cleanArray(formData.associationFeeIncludes),
          totalActualRent: toString(formData.totalActualRent),
          existingLeaseType: cleanArray(formData.existingLeaseType),
          leaseAmount: toString(formData.leaseAmount),
          leaseAmountFrequency: toString(formData.leaseAmountFrequency),
          leasePerUnit: toString(formData.leasePerUnit),
          pricePerUnit: toString(formData.pricePerUnit),
          businessType: cleanArray(formData.businessType),
          anchorsCoTenants: toString(formData.anchorsCoTenants),
          view: cleanArray(formData.view),
          propertyAttachedYN: toBool(formData.propertyAttachedYN),
          taxAnnualAmount: toString(formData.taxAnnualAmount),
          taxBlock: toString(formData.taxBlock),
          taxLot: toString(formData.taxLot),
          taxYear: toString(formData.taxYear),
          publicRemarks: toString(formData.publicRemarks),
        };

        // ==============================
        //  API CALL
        // ==============================
        const response = await fetch(`${baseUrl}/property/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const apiResponse = await response.json();

        if (response.ok || apiResponse.success === true) {
          console.log("API submission successful");

          if (apiResponse?.data) {
            localStorage.setItem("propertyId", apiResponse.data);
          }
          if (currentStep === 1 || currentStep === 4) {
            navigate("/myListings"); // Redirect to Home
            return;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "API Submission Failed",
            text: "There was an issue submitting the property data. Please try again.",
          });
          return;
        }
      } catch (error) {
        console.error("API Error:", error);
        Swal.fire({
          icon: "error",
          title: "API Error",
          text: "An error occurred while submitting the property data. Please try again.",
        });
        return;
      }
    }

    // ==============================
    //  NORMAL STEP NEXT
    // ==============================
    if (currentStep < totalSteps) {
      setError("");
      setCurrentStep(currentStep + 1);
    }
  };

  const handleFinalSubmit = async () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const hasOldOwnership = ownershipPreview.length > 0;
    const hasOldIdentity = identityPreview.length > 0;

    // VALIDATIONS
    if (!hasOldOwnership && !ownershipFile) {
      setOwnershipError("Please upload ownership document.");
      return;
    }
    if (!hasOldIdentity && !identityFile) {
      setIdentityError("Please upload identity proof.");
      return;
    }
    if (uploadedImages.length === 0) {
      setError("Please select at least one property image.");
      return;
    }

    setError("");
    setOwnershipError("");
    setIdentityError("");

    try {
      const propertyId = localStorage.getItem("propertyId");
      if (!propertyId) {
        setError("Property ID not found. Please complete previous step.");
        return;
      }

      const formDataToSend = new FormData();

      // Append propertyId & titleForUpdate logic (your existing logic)
      formDataToSend.append("propertyId", propertyId);

      const isOwnershipUpdated = !!ownershipFile;
      const isIdentityUpdated = !!identityFile;

      let titleForUpdate = "";
      if (isOwnershipUpdated && !isIdentityUpdated) titleForUpdate = "0";
      else if (!isOwnershipUpdated && isIdentityUpdated) titleForUpdate = "1";

      formDataToSend.append("titleForUpdate", titleForUpdate);

      // Append docs:
      if (ownershipFile) {
        formDataToSend.append("doc", ownershipFile);
      } else if (ownershipPreview.length > 0) {
        // Old ownership doc as JSON string
        formDataToSend.append(
          "oldOwnershipDoc",
          JSON.stringify(ownershipPreview[0])
        );
      }

      if (identityFile) {
        formDataToSend.append("doc", identityFile);
      } else if (identityPreview.length > 0) {
        // Old identity doc as JSON string
        formDataToSend.append(
          "oldIdentityDoc",
          JSON.stringify(identityPreview[0])
        );
      }

      // Append property images (only new files)
      uploadedImages.forEach((file) => {
        if (file instanceof File) formDataToSend.append("images", file);
      });

      // If no new images but old images exist, handle them as needed by backend
      // For example, if backend expects old images IDs in a separate key:
      if (
        !uploadedImages.some((f) => f instanceof File) &&
        previewImages.length > 0
      ) {
        // If backend expects old image IDs, send like this (replace "oldImages" with API's actual key):
        // formDataToSend.append("oldImages", JSON.stringify(previewImages.map(img => img.id)));
        // Otherwise, omit if backend already knows existing images for the property.
      }

      // Debug
      console.log("Final FormData:");
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0], ":", pair[1]);
      }

      // API call
      const response = await fetch(`${baseUrl}/property/add-doc`, {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();
      console.log("Upload Response:", data);

      if (
        response.ok ||
        data.status === 200 ||
        (data.message && data.message.toLowerCase().includes("success"))
      ) {
        Swal.fire({
          icon: "success",
          title: "Uploaded Successfully!",
          timer: 1500,
          showConfirmButton: false,
        });

        setTimeout(() => {
          navigate("/");
        }, 1200);
      } else {
        setError("Upload failed, please try again.");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      setError("Upload failed, please try again.");
    }
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    if (currentStep > 1) {
      if (currentStep === 5) return; // block step 4
      setCurrentStep(currentStep - 1);
    }
  };
  const storeys = Array.from({ length: 100 }, (_, i) => (i + 1).toString());
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        architecturalDropRef.current &&
        !architecturalDropRef.current.contains(event.target)
      ) {
        setArchitecturalOpen(false);
      }
      if (
        flooringDropRef.current &&
        !flooringDropRef.current.contains(event.target)
      ) {
        setFlooringOpen(false);
      }
      if (
        coolingDropRef.current &&
        !coolingDropRef.current.contains(event.target)
      ) {
        setCoolingOpen(false);
      }
      if (
        heatingDropRef.current &&
        !heatingDropRef.current.contains(event.target)
      ) {
        setHeatingOpen(false);
      }
      if (
        exteriorDropRef.current &&
        !exteriorDropRef.current.contains(event.target)
      ) {
        setExteriorOpen(false);
      }
      if (
        fireplaceDropRef.current &&
        !fireplaceDropRef.current.contains(event.target)
      ) {
        setFireplaceOpen(false);
      }
      if (
        parkingDropRef.current &&
        !parkingDropRef.current.contains(event.target)
      ) {
        setParkingOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-section">
            <div className="section-header">
              <span>Property Details</span>
            </div>
            <div className="property-form">
              {/* Property Type + Building Type */}
              {!listingId && (
                <div className="form-row">
                  <div className="form-group">
                    <label>Property Type</label>
                    <select
                      name="propertyType"
                      value={formData.propertyType}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {propertyTypeOptions.map((st) => (
                        <option key={st} value={st}>
                          {st}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Building Type */}
                  <div
                    className="form-group"
                    ref={dropdownRef}
                    style={{ position: "relative" }}
                  >
                    <label>Building Type</label>
                    <div
                      className="custom-select"
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        background: "#fff",
                        userSelect: "none",
                      }}
                      onClick={() => setDropdownOpen((prev) => !prev)}
                    >
                      {formData.buildingType?.length > 0
                        ? `${formData.buildingType.length} selected`
                        : "0 selected"}
                    </div>
                    {dropdownOpen && (
                      <div
                        className="dropdown-options"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        {buildingTypes.map((type) => (
                          <div
                            key={type}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormData((prev) => {
                                const selected = prev.buildingType || [];
                                return selected.includes(type)
                                  ? {
                                      ...prev,
                                      buildingType: selected.filter(
                                        (t) => t !== type
                                      ),
                                    }
                                  : {
                                      ...prev,
                                      buildingType: [...selected, type],
                                    };
                              });
                            }}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              background: formData.buildingType?.includes(type)
                                ? "rgb(20 71 136 / 81%)"
                                : "rgb(20 71 136 / 36%)",
                              borderBottom: "1px solid #eee",
                              color: "#fff",
                            }}
                          >
                            {type}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* Architectural Style + Year Built */}
              {!listingId && (
                <div className="form-row">
                  <div
                    className="form-group"
                    style={{ position: "relative" }}
                    ref={architecturalDropRef}
                  >
                    <label>Architectural Style</label>
                    <div
                      className="custom-select"
                      onClick={() => setArchitecturalOpen((prev) => !prev)}
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        background: "#fff",
                        userSelect: "none",
                      }}
                    >
                      {formData.architecturalStyle?.length > 0
                        ? `${formData.architecturalStyle.length} selected`
                        : "0 selected"}
                    </div>
                    {architecturalOpen && (
                      <div
                        className="dropdown-options"
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        {architectural_style?.map((style) => (
                          <div
                            key={style}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFormData((prev) => {
                                const selected = prev.architecturalStyle || [];
                                return selected.includes(style)
                                  ? {
                                      ...prev,
                                      architecturalStyle: selected.filter(
                                        (s) => s !== style
                                      ),
                                    }
                                  : {
                                      ...prev,
                                      architecturalStyle: [...selected, style],
                                    };
                              });
                            }}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              background: formData.architecturalStyle?.includes(
                                style
                              )
                                ? "rgb(20 71 136 / 81%)"
                                : "rgb(20 71 136 / 36%)",
                              borderBottom: "1px solid #eee",
                              color: "#fff",
                            }}
                          >
                            {style}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Year Built</label>
                    <select
                      name="yearBuilt"
                      value={formData.yearBuilt || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {years.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {/* Property Condition + Stories + Zoning */}
              {!listingId && (
                <div className="form-row">
                  <div className="form-group">
                    <label>Property Condition</label>
                    <input
                      type="text"
                      name="propertyCondition"
                      value={formData.propertyCondition || ""}
                      onChange={handleChange}
                      placeholder="Enter property condition"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Stories</label>
                    <input
                      type="text"
                      name="stories"
                      value={formData.stories || ""}
                      onChange={handleChange}
                      placeholder="Enter number of stories"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Zoning</label>
                    <input
                      type="text"
                      name="zoning"
                      value={formData.zoning || ""}
                      onChange={handleChange}
                      placeholder="Enter zoning information"
                      required
                    />
                  </div>
                </div>
              )}
              {/* Zoning Description */}
              {!listingId && (
                <div className="form-group full-width">
                  <label>Zoning Description</label>
                  <textarea
                    name="zoningDescription"
                    value={formData.zoningDescription || ""}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Enter zoning description"
                  />
                </div>
              )}
              {/* Parcel Number / Desired Value / Offer Starting Price */}
              <div className="form-row">
                {!listingId && (
                  <div className="form-group">
                    <label>Parcel Number</label>
                    <input
                      type="text"
                      name="parcelNumber"
                      value={formData.parcelNumber || ""}
                      onChange={handleChange}
                      placeholder="Enter parcel number"
                    />
                  </div>
                )}
                {!listingId && (
                  <div className="form-group">
                    <label>Desired Property Value</label>
                    <input
                      type="number"
                      name="listPrice"
                      value={formData.listPrice || ""}
                      onChange={handleChange}
                      placeholder="Enter desired property value"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Offer Starting Price</label>
                  <input
                    type="text"
                    name="offerStartingPrice"
                    value={
                      formData.offerStartingPrice
                        ? `$${formData.offerStartingPrice}`
                        : ""
                    }
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({
                        ...prev,
                        offerStartingPrice: rawValue,
                      }));
                    }}
                    placeholder="Enter offer starting price"
                    required
                  />
                </div>
              </div>
              {/* Offer Dates */}
              <div className="form-row">
                <div className="form-group">
                  <label>Offer Starting Date</label>
                  <input
                    type="date"
                    name="offerStartingDate" // FIXED
                    value={formData.offerStartingDate || ""} // FIXED
                    onChange={handleChange}
                    className="date-input"
                  />
                </div>
                <div className="form-group">
                  <label>Offer Ending Date</label>
                  <input
                    type="date"
                    name="offerEndingDate" // FIXED
                    value={formData.offerEndingDate || ""} // FIXED
                    onChange={handleChange}
                    className="date-input"
                  />
                </div>
              </div>
              {/* Times */}
              <div className="form-row">
                <div className="form-group">
                  <label>Offer Starting Time</label>
                  <select
                    name="time"
                    value={formData.time || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {timing.map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Offer Ending Time</label>
                  <select
                    name="endtime"
                    value={formData.endtime || ""}
                    onChange={handleChange}
                  >
                    <option value="">Select</option>
                    {timing.map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <>
            {/* ================= Main Form ================= */}
            <div className="form-section">
              <div className="property-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Address</label>
                    <Autocomplete
                      onLoad={(autocomplete) => {
                        autocompleteRef.current = autocomplete;
                      }}
                      onPlaceChanged={onPlaceSelect}
                      options={{
                        componentRestrictions: { country: "ca" }, // Restrict to Canada
                        types: ["address"],
                      }}
                    >
                      <input
                        type="text"
                        name="address"
                        value={formData.address || ""}
                        onChange={handleChange}
                        placeholder="Enter your address"
                        required
                      />
                    </Autocomplete>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Postal Code</label>
                    <input
                      type="text"
                      name="postalCode"
                      value={formData.postalCode || ""}
                      onChange={handleChange}
                      placeholder="Enter postal code"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Municipality</label>
                    <input
                      type="text"
                      name="municipality"
                      value={formData.municipality || ""}
                      onChange={handleChange}
                      placeholder="Enter municipality"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Street Number</label>
                    <input
                      type="text"
                      name="streetNumber"
                      value={formData.streetNumber || ""}
                      onChange={handleChange}
                      placeholder="Enter street number"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Street Name</label>
                    <input
                      type="text"
                      name="streetName"
                      value={formData.streetName || ""}
                      onChange={handleChange}
                      placeholder="Enter street name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Location Direction</label>
                    <input
                      type="text"
                      name="locationDirection"
                      value={formData.directions || ""}
                      onChange={handleChange}
                      placeholder="Enter location direction"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Subdivision Name</label>
                    <input
                      type="text"
                      name="subdivisionName"
                      value={formData.subdivisionName || ""}
                      onChange={handleChange}
                      placeholder="Enter subdivision name"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Unit Number</label>
                    <input
                      type="text"
                      name="unitNumber"
                      value={formData.unitNumber || ""}
                      onChange={handleChange}
                      placeholder="Enter unit number"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleChange}
                      placeholder="Enter city"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Select Province</label>
                    <select
                      name="stateOrProvince"
                      value={formData.stateOrProvince || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {province.map((st) => (
                        <option key={st} value={st}>
                          {st}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-row verifu">
                  <div className="form-group">
                    <label>Country</label>
                    <input
                      type="text"
                      name="country"
                      value="Canada"
                      readOnly
                      placeholder="Canada"
                    />
                  </div>
                  {/* Button uses the verification lock logic */}
                  <button
                    className="verifiy"
                    onClick={handleVerifyAddress}
                    disabled={isLoading || isAddressVerified}
                    style={{
                      backgroundColor: isAddressVerified
                        ? "rgb(20 71 136 / 8%)"
                        : "",
                    }}
                  >
                    {isLoading
                      ? "Verifying..."
                      : isAddressVerified
                      ? "Verified"
                      : "Verify Address"}
                  </button>
                </div>
              </div>
            </div>
          </>
        );
      case 3:
        return (
          <div className="form-section">
            <div className="property-form">
              <span
                style={{
                  fontWeight: 800,
                  marginTop: "15px",
                }}
              >
                Property Features
              </span>
              {/* ================= ROW 1 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Total Number of Bedrooms</label>
                  <input
                    type="number"
                    name="bedroomsTotal"
                    value={formData.bedroomsTotal}
                    onChange={handleChange}
                    placeholder="Enter total number of bedrooms"
                  />
                </div>
                <div className="form-group">
                  <label>Bedrooms Counts Above Grade</label>
                  <input
                    type="number"
                    name="bedroomsAboveGrade"
                    value={formData.bedroomsAboveGrade}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Bedrooms Counts Below Grade</label>
                  <input
                    type="number"
                    name="bedroomsBelowGrade"
                    value={formData.bedroomsBelowGrade}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {/* ================= ROW 2 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Full Bathrooms</label>
                  <input
                    type="number"
                    name="bathroomsTotalInteger"
                    value={formData.bathroomsTotalInteger}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Half Bathrooms</label>
                  <input
                    type="number"
                    name="bathroomsPartial"
                    value={formData.bathroomsPartial || ""}
                    onChange={handleChange}
                    placeholder="Enter number of half bathrooms"
                  />
                </div>
                <div className="form-group">
                  <label>Number of Rooms</label>
                  <input
                    type="number"
                    name="rooms"
                    value={formData.rooms}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {/* ================= ROW 3 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Living Area</label>
                  <input
                    type="number"
                    name="livingArea"
                    value={formData.livingArea || ""}
                    onChange={handleChange}
                    placeholder="Enter living area"
                  />
                </div>
                <div className="form-group">
                  <label>Living Area Units</label>
                  <input
                    type="text"
                    name="livingAreaUnits"
                    value={formData.livingAreaUnits || ""}
                    onChange={handleChange}
                    placeholder="Enter living area units"
                  />
                </div>
                <div className="form-group">
                  <label>Living Area Source</label>
                  <input
                    type="text"
                    name="livingAreaSource"
                    value={formData.livingAreaSource || ""}
                    onChange={handleChange}
                    placeholder="Enter living area source"
                  />
                </div>
              </div>
              {/* ================= ROW 4 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Living Area Minimum</label>
                  <input
                    type="number"
                    name="livingAreaMinimum"
                    value={formData.livingAreaMinimum}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Living Area Maximum</label>
                  <input
                    type="number"
                    name="livingAreaMaximum"
                    value={formData.livingAreaMaximum}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Building Area</label>
                  <input
                    type="number"
                    name="buildingAreaTotal"
                    value={formData.buildingAreaTotal}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* ================= ROW 5 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Building Area Units</label>
                  <input
                    type="text"
                    name="buildingAreaUnits"
                    value={formData.buildingAreaUnits || ""}
                    onChange={handleChange}
                    placeholder="Enter building area units"
                  />
                </div>

                <div className="form-group">
                  <label>Building Features</label>
                  <input
                    type="text"
                    name="buildingFeatures"
                    value={formData.buildingFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter building features"
                  />
                </div>

                <div className="form-group">
                  <label>Basement Available</label>
                  <input
                    type="text"
                    name="basement"
                    value={formData.basement || ""}
                    onChange={handleChange}
                    placeholder="Enter basement availability"
                  />
                </div>
              </div>

              {/* ================= ROW 6 ================= */}
              <div className="form-row">
                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={flooringDropRef}
                >
                  <label>Flooring Type</label>

                  <div
                    className="custom-select"
                    onClick={() => setFlooringOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.flooring?.length > 0
                      ? `${formData.flooring.length} selected`
                      : "0 selected"}
                  </div>

                  {flooringOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {flooring.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.flooring || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    flooring: selected.filter(
                                      (t) => t !== type
                                    ),
                                  }
                                : {
                                    ...prev,
                                    flooring: [...selected, type],
                                  };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.flooring?.includes(type)
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={coolingDropRef}
                >
                  <label>Cooling</label>

                  <div
                    className="custom-select"
                    onClick={() => setCoolingOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.cooling?.length > 0
                      ? `${formData.cooling.length} selected`
                      : "0 selected"}
                  </div>

                  {coolingOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {cooling.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.cooling || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    cooling: selected.filter((t) => t !== type),
                                  }
                                : { ...prev, cooling: [...selected, type] };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.cooling?.includes(type)
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={heatingDropRef}
                >
                  <label>Heating</label>

                  <div
                    className="custom-select"
                    onClick={() => setHeatingOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.heating?.length > 0
                      ? `${formData.heating.length} selected`
                      : "0 selected"}
                  </div>

                  {heatingOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {heatings.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.heating || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    heating: selected.filter((t) => t !== type),
                                  }
                                : { ...prev, heating: [...selected, type] };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.heating?.includes(type)
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* ================= ROW 7 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Foundation Details</label>
                  <input
                    type="text"
                    name="foundationDetails"
                    value={formData.foundationDetails || ""}
                    onChange={handleChange}
                    placeholder="Enter foundation details"
                  />
                </div>

                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={exteriorDropRef}
                >
                  <label>Exterior Features</label>

                  {/* Selected Count Box */}
                  <div
                    className="custom-select"
                    onClick={() => setExteriorOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.exteriorFeatures?.length > 0
                      ? `${formData.exteriorFeatures.length} selected`
                      : "0 selected"}
                  </div>

                  {/* Dropdown Options */}
                  {exteriorOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {exterior.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.exteriorFeatures || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    exteriorFeatures: selected.filter(
                                      (t) => t !== type
                                    ),
                                  }
                                : {
                                    ...prev,
                                    exteriorFeatures: [...selected, type],
                                  };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.exteriorFeatures?.includes(
                              type
                            )
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Roof</label>
                  <input
                    type="text"
                    name="roof"
                    value={formData.roof || ""}
                    onChange={handleChange}
                    placeholder="Enter roof type"
                  />
                </div>
              </div>

              {/* ================= ROW 8 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Water Source</label>
                  <input
                    type="text"
                    name="waterSource"
                    value={formData.waterSource || ""}
                    onChange={handleChange}
                    placeholder="Enter water source"
                  />
                </div>

                <div className="form-group">
                  <label>Sewerage Type</label>
                  <input
                    type="text"
                    name="sewer"
                    value={formData.sewer}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Electric Type</label>
                  <input
                    type="text"
                    name="electric"
                    value={formData.electric || ""}
                    onChange={handleChange}
                    placeholder="Enter electric type"
                  />
                </div>
              </div>

              {/* ================= ROW 9 (LAST) ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Utilities Available</label>
                  <input
                    type="text"
                    name="utilities"
                    value={formData.utilities || ""}
                    onChange={handleChange}
                    placeholder="Enter available utilities"
                  />
                </div>

                <div className="form-group">
                  <label>Irrigation Source</label>
                  <input
                    type="text"
                    name="irrigationSource"
                    value={formData.irrigationSource || ""}
                    onChange={handleChange}
                    placeholder="Enter irrigation source"
                  />
                </div>

                <div className="form-group">
                  <label>Fireplace Total</label>
                  <input
                    type="number"
                    name="fireplacesTotal"
                    value={formData.fireplacesTotal || ""}
                    onChange={handleChange}
                    placeholder="Enter number of fireplaces"
                  />
                </div>
                <div className="form-group">
                  <label>Fireplace</label>
                  <select
                    name="fireplaceYN"
                    value={formData.fireplaceYN || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select fireplace</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {/* ================= fireplace features ================= */}
              <div className="form-row">
                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={fireplaceDropRef}
                >
                  <label>Fireplace Features</label>

                  {/* Selected Count Box */}
                  <div
                    className="custom-select"
                    onClick={() => setFireplaceOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.fireplaceFeatures?.length > 0
                      ? `${formData.fireplaceFeatures.length} selected`
                      : "0 selected"}
                  </div>

                  {/* Dropdown Options */}
                  {fireplaceOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {fireplaced.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.fireplaceFeatures || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    fireplaceFeatures: selected.filter(
                                      (t) => t !== type
                                    ),
                                  }
                                : {
                                    ...prev,
                                    fireplaceFeatures: [...selected, type],
                                  };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.fireplaceFeatures?.includes(
                              type
                            )
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Accessibility Features</label>
                  <input
                    type="text"
                    name="accessibilityFeatures"
                    value={formData.accessibilityFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter accessibility features"
                  />
                </div>

                <div className="form-group">
                  <label>Construction Materials</label>
                  <input
                    type="text"
                    name="constructionMaterials"
                    value={formData.constructionMaterials || ""}
                    onChange={handleChange}
                    placeholder="Enter construction materials"
                  />
                </div>
              </div>

              {/* ================= Appliances ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Appliances</label>
                  <input
                    type="text"
                    name="appliances"
                    value={formData.appliances || ""}
                    onChange={handleChange}
                    placeholder="Enter appliances"
                  />
                </div>

                <div className="form-group">
                  <label>Other Equipment</label>
                  <input
                    type="text"
                    name="otherEquipment"
                    value={formData.otherEquipment || ""}
                    onChange={handleChange}
                    placeholder="Enter other equipment"
                  />
                </div>

                <div className="form-group">
                  <label>Current Use</label>
                  <input
                    type="text"
                    name="currentUse"
                    value={formData.currentUse || ""}
                    onChange={handleChange}
                    placeholder="Enter Current Use"
                  />
                </div>
              </div>

              {/* ================= Last ================= */}

              <div className="form-row">
                <div className="form-group">
                  <label>Possible Use</label>
                  <input
                    type="text"
                    name="possibleUse"
                    value={formData.possibleUse || ""}
                    onChange={handleChange}
                    placeholder="Enter Possible Use"
                  />
                </div>
                <div className="form-group">
                  <label>Security Features</label>
                  <input
                    type="text"
                    name="securityFeatures"
                    value={formData.securityFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter security features"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 4:
        return (
          <div className="form-section">
            <div className="property-form">
              {/* ================= ROW 1 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Number Of Buildings</label>
                  <input
                    type="number"
                    name="numberOfBuildings"
                    value={formData.numberOfBuildings || ""}
                    onChange={handleChange}
                    placeholder="Enter number of buildings"
                  />
                </div>

                <div className="form-group">
                  <label>Number of Units Total</label>
                  <input
                    type="number"
                    name="numberOfUnitsTotal"
                    value={formData.numberOfUnitsTotal || ""}
                    onChange={handleChange}
                    placeholder="Enter total number of units"
                  />
                </div>

                <div className="form-group">
                  <label>Lot Features</label>
                  <input
                    type="text"
                    name="lotFeatures"
                    value={formData.lotFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter lot Features"
                  />
                </div>

                <div className="form-group">
                  <label>Lot Size Area</label>
                  <input
                    type="number"
                    name="lotSizeArea"
                    value={formData.lotSizeArea || ""}
                    onChange={handleChange}
                    placeholder="Enter lot size area"
                  />
                </div>
              </div>

              {/* ================= ROW 2 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Lot Size Dimensions</label>
                  <input
                    type="number"
                    name="lotSizeDimensions"
                    value={formData.lotSizeDimensions || ""}
                    onChange={handleChange}
                    placeholder="Enter lot size dimensions"
                  />
                </div>

                <div className="form-group">
                  <label>Lot Size Units</label>
                  <input
                    type="text"
                    name="lotSizeUnits"
                    value={formData.lotSizeUnits || ""}
                    onChange={handleChange}
                    placeholder="Enter lot size units"
                  />
                </div>

                <div className="form-group">
                  <label>Frontage (Front Length)</label>
                  <input
                    type="text"
                    name="frontageLengthNumeric"
                    value={formData.frontageLengthNumeric || ""}
                    onChange={handleChange}
                    placeholder="Enter frontage length"
                  />
                </div>
              </div>

              {/* ================= ROW 3 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Frontage Unit</label>
                  <input
                    type="text"
                    name="frontageLengthNumericUnits"
                    value={formData.frontageLengthNumericUnits || ""}
                    onChange={handleChange}
                    placeholder="Enter frontage unit"
                  />
                </div>

                <div className="form-group">
                  <label>Pool Features</label>
                  <input
                    type="text"
                    name="poolFeatures"
                    value={formData.poolFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter pool features"
                  />
                </div>

                <div className="form-group">
                  <label>Fencing Available</label>
                  <input
                    type="text"
                    name="fencing"
                    value={formData.fencing || ""}
                    onChange={handleChange}
                    placeholder="Enter fencing availability"
                  />
                </div>
              </div>

              {/* ================= ROW 4 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Road Surface Type</label>
                  <input
                    type="text"
                    name="roadSurfaceType"
                    value={formData.roadSurfaceType || ""}
                    onChange={handleChange}
                    placeholder="Enter road surface type"
                  />
                </div>

                <div
                  className="form-group"
                  style={{ position: "relative" }}
                  ref={parkingDropRef}
                >
                  <label>Parking</label>

                  {/* Selected Count Box */}
                  <div
                    className="custom-select"
                    onClick={() => setParkingOpen((prev) => !prev)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      background: "#fff",
                      userSelect: "none",
                    }}
                  >
                    {formData.parkingFeatures?.length > 0
                      ? `${formData.parkingFeatures.length} selected`
                      : "0 selected"}
                  </div>

                  {/* Dropdown Options */}
                  {parkingOpen && (
                    <div
                      className="dropdown-options"
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                      }}
                    >
                      {Parking.map((type) => (
                        <div
                          key={type}
                          onClick={(e) => {
                            e.stopPropagation();
                            setFormData((prev) => {
                              const selected = prev.parkingFeatures || [];
                              return selected.includes(type)
                                ? {
                                    ...prev,
                                    parkingFeatures: selected.filter(
                                      (t) => t !== type
                                    ),
                                  }
                                : {
                                    ...prev,
                                    parkingFeatures: [...selected, type],
                                  };
                            });
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            background: formData.parkingFeatures?.includes(type)
                              ? "rgb(20 71 136 / 81%)"
                              : "rgb(20 71 136 / 36%)",
                            borderBottom: "1px solid #eee",
                            color: "#fff",
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Total Parking Available</label>
                  <input
                    type="text"
                    name="parkingTotal"
                    value={formData.parkingTotal || ""}
                    onChange={handleChange}
                    placeholder="Enter total parking available"
                  />
                </div>
              </div>

              {/* ================= ROW 5 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Waterfront Features</label>
                  <input
                    type="text"
                    name="waterfrontFeatures"
                    value={formData.waterfrontFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter waterfront features"
                  />
                </div>

                <div className="form-group">
                  <label>Water Body Name</label>
                  <input
                    type="text"
                    name="waterBodyName"
                    value={formData.waterBodyName || ""}
                    onChange={handleChange}
                    placeholder="Enter water body name"
                  />
                </div>

                <div className="form-group">
                  <label>Community Features</label>
                  <input
                    type="text"
                    name="communityFeatures"
                    value={formData.communityFeatures || ""}
                    onChange={handleChange}
                    placeholder="Enter community features"
                  />
                </div>
              </div>

              {/* ================= ROW 6 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Association Fee</label>
                  <input
                    type="number"
                    name="associationFee"
                    value={formData.associationFee || ""}
                    onChange={handleChange}
                    placeholder="Enter association fee"
                  />
                </div>

                <div className="form-group">
                  <label>Association Fee Frequency</label>
                  <input
                    type="text"
                    name="associationFeeFrequency"
                    value={formData.associationFeeFrequency || ""}
                    onChange={handleChange}
                    placeholder="Enter association fee frequency"
                  />
                </div>

                <div className="form-group">
                  <label>Association Name</label>
                  <input
                    type="text"
                    name="associationName"
                    value={formData.associationName || ""}
                    onChange={handleChange}
                    placeholder="Enter association name"
                  />
                </div>
              </div>

              {/* ================= ROW 7 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Association Fee Includes</label>
                  <input
                    type="text"
                    name="associationFeeIncludes"
                    value={formData.associationFeeIncludes || ""}
                    onChange={handleChange}
                    placeholder="Enter what the fee includes"
                  />
                </div>

                <div className="form-group">
                  <label>Existing Lease Type</label>
                  <input
                    type="text"
                    name="existingLeaseType"
                    value={formData.existingLeaseType || ""}
                    onChange={handleChange}
                    placeholder="Enter existing lease type"
                  />
                </div>

                <div className="form-group">
                  <label>Actual Rent</label>
                  <input
                    type="number"
                    name="totalActualRent"
                    value={formData.totalActualRent || ""}
                    onChange={handleChange}
                    placeholder="Enter actual rent"
                  />
                </div>
              </div>

              {/* ================= ROW 8 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Lease Amount</label>
                  <input
                    type="text"
                    name="leaseAmount"
                    value={formData.leaseAmount || ""}
                    onChange={handleChange}
                    placeholder="Enter lease amount"
                  />
                </div>

                <div className="form-group">
                  <label>Lease Amount Frequency</label>
                  <input
                    type="text"
                    name="leaseAmountFrequency"
                    value={formData.leaseAmountFrequency || ""}
                    onChange={handleChange}
                    placeholder="Enter lease payment frequency"
                  />
                </div>

                <div className="form-group">
                  <label>Lease Per Unit</label>
                  <input
                    type="text"
                    name="leasePerUnit"
                    value={formData.leasePerUnit || ""}
                    onChange={handleChange}
                    placeholder="Enter lease per unit"
                  />
                </div>
              </div>

              {/* ================= ROW 9 ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Price Per Unit</label>
                  <input
                    type="text"
                    name="pricePerUnit"
                    value={formData.pricePerUnit || ""}
                    onChange={handleChange}
                    placeholder="Enter price per unit"
                  />
                </div>

                <div className="form-group">
                  <label>Business Type</label>
                  <input
                    type="text"
                    name="businessType"
                    value={formData.businessType || ""}
                    onChange={handleChange}
                    placeholder="Enter business type"
                  />
                </div>

                <div className="form-group">
                  <label>Anchors / Co-Tenants</label>
                  <input
                    type="text"
                    name="anchorsCoTenants"
                    value={formData.anchorsCoTenants || ""}
                    onChange={handleChange}
                    placeholder="Enter anchors / co-tenants"
                  />
                </div>
              </div>

              {/* ================= front ROW ================= */}
              <div className="form-row">
                <div className="form-group">
                  <label>Front View</label>
                  <input
                    type="text"
                    name="view"
                    value={formData.view || ""}
                    onChange={handleChange}
                    placeholder="Enter front view"
                  />
                </div>

                <div className="form-group">
                  <label>Property Attached</label>
                  <select
                    name="propertyAttachedYN"
                    value={formData.propertyAttachedYN || ""}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Tax Annual Amount</label>
                  <input
                    type="number"
                    name="taxAnnualAmount"
                    value={formData.taxAnnualAmount || ""}
                    onChange={handleChange}
                    placeholder="Enter Annual Tax Amount"
                  />
                </div>
              </div>
              {/* ================= last ROW ================= */}

              <div className="form-row">
                <div className="form-group">
                  <label>Tax Block</label>
                  <input
                    type="text"
                    name="taxBlock"
                    value={formData.taxBlock || ""}
                    onChange={handleChange}
                    placeholder="Enter Tax Block"
                  />
                </div>

                <div className="form-group">
                  <label>Tax Lot</label>
                  <input
                    type="text"
                    name="taxLot"
                    value={formData.taxLot || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Tax Year</label>
                  <input
                    type="number"
                    name="taxYear"
                    value={formData.taxYear || ""}
                    onChange={handleChange}
                    placeholder="Enter Tax Year"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Listing Description</label>
                  <input
                    type="text"
                    name="publicRemarks"
                    value={formData.publicRemarks || ""}
                    onChange={handleChange}
                    placeholder="Enter Listing Description"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <>
            <div>
              <div className="upconflx">
                {/* ---------- 1. Ownership Docs ---------- */}
                <div className="upload-photos-container">
                  <div className="upload-header">
                    <h3>Please upload proof of ownership or Listing agreement</h3>
                  </div>

                  <div
                    className="upload-box"
                    onClick={() => ownershipRef.current.click()}
                  >
                    <div className="upload-icon">
                      <img src={Uploadicon} alt="" />
                    </div>
                    <p>Ownership Listing agreement</p>
                    <input
                      type="file"
                      ref={ownershipRef}
                      multiple
                      accept=".pdf,image/*"
                      onChange={handleOwnershipChange}
                      hidden
                    />
                  </div>

                  {ownershipError && (
                    <p style={{ color: "red" }}>{ownershipError}</p>
                  )}

                  <div className="uploaded-images-container">
                    {ownershipPreview.length > 0 &&
                      ownershipPreview.map((item, index) => (
                        <div key={index} className="file-row">
                          <span className="file-name">{getFileName(item)}</span>

                          <button
                            type="button"
                            className="delete-btn"
                            onClick={() => removeOwnership(index)}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                  </div>
                </div>

                {/* ---------- 2. Owner Identity Proofs ---------- */}
                <div className="upload-photos-container">
                  <div className="upload-header">
                    <h3>Please upload Owner Identity Proofs</h3>
                  </div>

                  <div
                    className="upload-box"
                    onClick={() => identityRef.current.click()}
                  >
                    <div className="upload-icon">
                      <img src={Uploadicon} alt="" />
                    </div>
                    <p>Identity Proofs</p>
                    <input
                      type="file"
                      ref={identityRef}
                      multiple
                      accept=".pdf,image/*"
                      onChange={handleIdentityChange}
                      hidden
                    />
                  </div>

                  {identityError && (
                    <p style={{ color: "red" }}>{identityError}</p>
                  )}

                  <div className="uploaded-images-container">
                    {identityPreview.length > 0 &&
                      identityPreview.map((item, index) => (
                        <div key={index} className="file-row">
                          <span className="file-name">{getFileName(item)}</span>

                          <button
                            type="button"
                            className="delete-btn"
                            onClick={() => removeIdentity(index)}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              {/* ---------- 3. PROPERTY PHOTOS (Your Original Code – NO CHANGE) ---------- */}
              <div className="upload-photos-container">
                <div className="upload-header">
                  <h3>Upload Property Photos</h3>
                  <FaInfoCircle className="info-icon" />
                </div>

                <div className="upload-box" onClick={handleClick}>
                  <div className="upload-icon">
                    <img src={Uploadicon} alt="" />
                  </div>
                  <p>Upload Photos</p>
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    accept="image/*"
                    onChange={handleFileChange}
                    hidden
                  />
                </div>

                <p className="upload-note">
                  *Please upload property photos in landscape orientation
                  (horizontal) only. Use 16:9 aspect ratio (1280×720 px or
                  higher). Portrait images will NOT be accepted.*
                </p>

                {error && <p style={{ color: "red" }}>{error}</p>}

                <div className="uploaded-images-container">
                  {previewImages.length > 0 && (
                    <div className="image-thumbnails">
                      {previewImages.map((item, index) => (
                        <div key={index} className="image-thumbnail">
                          <img src={item.url} alt={`preview-${index}`} />
                          <button
                            type="button"
                            onClick={() => handleImageRemove(index)}
                            className="remove-image"
                          >
                            ❌
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      try {
        let apiUrl = "";
        const baseUrl = process.env.REACT_APP_API_BASE_URL;

        if (!propeId || propeId === "null" || propeId === "") {
          apiUrl = `${baseUrl}/property/realtor-id/${propertyId}`;
        } else if (!userId || userId === "null") {
          apiUrl = `${baseUrl}/property/${propertyId}`;
        } else {
          apiUrl = `${baseUrl}/property/${propertyId}/user-id/${userId}`;
        }

        // ❌ WRONG: d used before response
        // if (d.propertyImages) {}

        const response = await axios.get(apiUrl);

        if (response.data.status === 200) {
          const d = response.data.data;
          setListingId(d.listingId || null);
          setIsResidential(d.residential === true);

          // ---------------- 1. SET PROPERTY IMAGES ----------------
          if (d.propertyImages && d.propertyImages.length > 0) {
            setPreviewImages(
              d.propertyImages.map((img) => ({
                id: img.id,
                url: img.imageUrl,
                isNew: false,
              }))
            );
          }

          // ---------------- 2. SET DOCUMENTS ----------------
          // MUST save id + url both (remove API needs id)
          if (d.docDisclaimer && d.docDisclaimer.length > 0) {
            setOwnershipPreview(
              d.docDisclaimer[0]
                ? [{ id: d.docDisclaimer[0].id, url: d.docDisclaimer[0].url }]
                : []
            );

            setIdentityPreview(
              d.docDisclaimer[1]
                ? [{ id: d.docDisclaimer[1].id, url: d.docDisclaimer[1].url }]
                : []
            );
          }
          const bidding = d?.biddingDetails || null;
          // ---------------- 3. SET FORM DATA ----------------
          setFormData({
            propertyType: d.propertySubType || "",
            buildingType: d.structureType || [],
            architecturalStyle: d.architecturalStyle || [],
            yearBuilt: d.yearBuilt || "",
            propertyCondition: d.propertyCondition || [],
            stories: d.stories || "",
            zoning: d.zoning || [],
            zoningDescription: d.zoningDescription || "",
            parcelNumber: d.parcelNumber || [],
            listPrice: d.listPrice || "",
            offerStartingPrice: bidding?.offerStartingPrice || "",

            offerStartingDate: bidding?.bidingStartDateTime
              ? formatDateForInput(bidding.bidingStartDateTime)
              : "",

            offerEndingDate: bidding?.bidingEndDateTime
              ? formatDateForInput(bidding.bidingEndDateTime)
              : "",

            time: bidding?.bidingStartDateTime
              ? getTimeFromDateTime(bidding.bidingStartDateTime)
              : "",

            endtime: bidding?.bidingEndDateTime
              ? getTimeFromDateTime(bidding.bidingEndDateTime)
              : "",

            // Address
            address: d.unparsedAddress || "",
            streetName: d.streetName || "",
            streetNumber: d.streetNumber || "",
            unitNumber: d.unitNumber || "",
            subdivisionName: d.subdivisionName || "",
            municipality: d.municipality || "",
            postalCode: d.postalCode || "",
            city: d.city || "",
            stateOrProvince: d.stateOrProvince || "",
            country: d.country || "Canada",
            directions: d.directions || "",
            latitude: d.latitude || "",
            longitude: d.longitude || "",

            // Interior
            bedroomsTotal: d.bedroomsTotal || "",
            bedroomsAboveGrade: d.bedroomsAboveGrade || "",
            bedroomsBelowGrade: d.bedroomsBelowGrade || "",
            bathroomsTotalInteger: d.bathroomsTotalInteger || "",
            bathroomsPartial: d.bathroomsPartial || "",
            rooms: d.rooms || "",
            livingArea: d.livingArea || "",
            livingAreaUnits: d.livingAreaUnits || "",
            livingAreaSource: d.livingAreaSource || "",
            livingAreaMinimum: d.livingAreaMinimum || "",
            livingAreaMaximum: d.livingAreaMaximum || "",
            buildingAreaTotal: d.buildingAreaTotal || "",
            buildingAreaUnits: d.buildingAreaUnits || "",
            buildingFeatures: d.buildingFeatures || [],
            basement: d.basement || [],
            flooring: d.flooring || [],
            cooling: d.cooling || [],
            heating: d.heating || [],
            foundationDetails: d.foundationDetails || [],
            exteriorFeatures: d.exteriorFeatures || [],
            roof: d.roof || [],
            waterSource: d.waterSource || [],
            sewer: d.sewer || [],
            electric: d.electric || [],
            utilities: d.utilities || [],
            irrigationSource: d.irrigationSource || [],
            fireplacesTotal: d.fireplacesTotal || "",
            fireplaceFeatures: d.fireplaceFeatures || [],
            accessibilityFeatures: d.accessibilityFeatures || [],
            constructionMaterials: d.constructionMaterials || [],
            appliances: d.appliances || [],
            otherEquipment: d.otherEquipment || [],
            securityFeatures: d.securityFeatures || [],
            currentUse: d.currentUse || [],
            possibleUse: d.possibleUse || [],

            // Exterior
            numberOfBuildings: d.numberOfBuildings || "",
            numberOfUnitsTotal: d.numberOfUnitsTotal || "",
            lotFeatures: d.lotFeatures || [],
            lotSizeArea: d.lotSizeArea || "",
            lotSizeDimensions: d.lotSizeDimensions || "",
            lotSizeUnits: d.lotSizeUnits || "",
            frontageLengthNumeric: d.frontageLengthNumeric || "",
            frontageLengthNumericUnits: d.frontageLengthNumericUnits || "",
            poolFeatures: d.poolFeatures || [],
            fencing: d.fencing || [],
            roadSurfaceType: d.roadSurfaceType || [],
            parkingFeatures: d.parkingFeatures || [],
            parkingTotal: d.parkingTotal || "",
            waterfrontFeatures: d.waterfrontFeatures || [],
            waterBodyName: d.waterBodyName || "",
            communityFeatures: d.communityFeatures || [],
            associationFee: d.associationFee || "",
            associationFeeFrequency: d.associationFeeFrequency || "",
            associationName: d.associationName || "",
            associationFeeIncludes: d.associationFeeIncludes || [],
            totalActualRent: d.totalActualRent || "",
            existingLeaseType: d.existingLeaseType || [],
            leaseAmount: d.leaseAmount || "",
            leaseAmountFrequency: d.leaseAmountFrequency || "",
            leasePerUnit: d.leasePerUnit || "",
            pricePerUnit: d.pricePerUnit || "",
            businessType: d.businessType || [],
            anchorsCoTenants: d.anchorsCoTenants || "",
            view: d.view || [],
            propertyAttachedYN: d.propertyAttachedYN || false,
            taxAnnualAmount: d.taxAnnualAmount || "",
            taxBlock: d.taxBlock || "",
            taxLot: d.taxLot || "",
            taxYear: d.taxYear || "",
            publicRemarks: d.publicRemarks || "",
          });
        } else {
          setError("Failed to fetch property details.");
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching property data.");
      }
    };
    // console.log("START TIME:", formData.time);
    // console.log("END TIME:", formData.endtime);
    // console.log("TIMING OPTIONS:", timing);

    fetchPropertyDetails();
  }, [propertyId, propeId, userId]);

  return (
    <div className="ediscroll">
      <Header />
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={libraries}
      >
        <div className="add-property-container newphjio">
          <div className="ADDmls">
            <h2 className="form-title">Edit Property</h2>
            {/* <button className="save-btn">Add Property By MLS</button> */}
          </div>
          {!listingId && (
            <div className="form-steps">
              Step {currentStep} of {totalSteps}
            </div>
          )}
          <form className="adpropmviv">
            {renderStep()}
            {error && <p style={{ color: "red", margin: "10px 0" }}>{error}</p>}
            {currentStep !== 5 && !listingId && (
              <h3 className="notes">
                Note: If you don't have information for a field, simply leave it
                blank/empty.
              </h3>
            )}

            <div className="form-navigation">
              {currentStep > 1 && (
                <button className="prev-button" onClick={handlePrevious}>
                  Previous
                </button>
              )}
              {currentStep < totalSteps ? (
                // <button className="next-button" onClick={handleNext}>
                //   Next / submit
                // </button>
                <button className="next-button" onClick={handleNext}>
                  {listingId ? "Submit" : "Next"}
                </button>
              ) : (
                <button
                  type="button"
                  className="submit-button"
                  onClick={handleFinalSubmit}
                >
                  Submit
                </button>
              )}
            </div>
          </form>
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup-box">
                <button
                  className="close-btn"
                  onClick={() => setShowPopup(false)}
                >
                  ✖
                </button>
                <h3>Verify Location on Map</h3>

                <GoogleMap
                  mapContainerStyle={{ width: "100%", height: "400px" }}
                  zoom={selectedPosition.lat === 20.5937 ? 4 : 14}
                  center={selectedPosition}
                  onClick={(e) => {
                    setSelectedPosition({
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    });
                  }}
                >
                  <Marker
                    position={selectedPosition}
                    draggable={true}
                    onDragEnd={(e) => {
                      setSelectedPosition({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                    }}
                  />
                </GoogleMap>

                <button
                  className="save-btn"
                  style={{ marginTop: "11px" }}
                  onClick={() => {
                    const currentLat = selectedPosition.lat;
                    const currentLng = selectedPosition.lng;

                    setFormData((prev) => {
                      const { address, city, postalCode } = prev;
                      const currentAddressString = `${address}, ${city}, ${postalCode}, Canada`;

                      // FINAL STEP: Set verified status and save the verified address string
                      setIsAddressVerified(true);
                      setLastVerifiedAddress(currentAddressString);

                      return {
                        ...prev,
                        lat: currentLat,
                        lng: currentLng,
                      };
                    });

                    setShowPopup(false);
                  }}
                >
                  Save Location
                </button>
              </div>
            </div>
          )}
        </div>
      </LoadScript>
      <Footer />
    </div>
  );
}

export default EditProperty;
